import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

export interface MailHistoryItem {
  id: number;
  uuid: string;
  fromMail?: string;
  toMail?: string;
  ccMail?: string;
  subject?: string;
  status: 'SENT' | 'FAILED' | 'SKIPPED';
  errorMessage?: string;
  entityCode?: string;
  processSlug?: string;
  statusSlug?: string;
  roleName?: string;
  requestUuid?: string;
  referenceType?: string;
  referenceId?: number;
  category?: string;
  source?: string;
  hasAttachment: boolean;
  attachmentName?: string;
  resentFromId?: number;
  smtpMessageId?: string;
  sentAt?: string;
  createdAt: string;
  canResend?: boolean;
  bodyMd?: string;
}

export interface MailHistoryListResponse {
  total: number;
  page: number;
  limit: number;
  pages: number;
  items: MailHistoryItem[];
}

@Injectable({ providedIn: 'root' })
export class MailManagementService {
  private http = inject(HttpClient);
  private base = Global.url + 'V1/mail-history';

  // Consulta lista paginada de correos con filtros
  getHistory(filters: Record<string, any> = {}): Observable<MailHistoryListResponse> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, val]) => {
      if (val != null && val !== '') params = params.set(key, String(val));
    });
    return this.http.get<MailHistoryListResponse>(this.base, { params });
  }

  // Obtiene detalle completo con cuerpo HTML y Markdown
  getByUuid(uuid: string): Observable<MailHistoryItem & { bodyHtml?: string; bodyText?: string; bodyMd?: string }> {
    return this.http.get<any>(`${this.base}/${uuid}`);
  }

  // Reenvia correo auditado con destinatario y copia opcionales
  resend(uuid: string, payload?: { toMail?: string; ccMail?: string } | string, file?: File): Observable<any> {
    const to = (typeof payload === 'string' ? payload : payload?.toMail)?.trim();
    const cc = (typeof payload === 'object' ? payload?.ccMail : undefined)?.trim();
    if (file) {
      const fd = new FormData();
      fd.append('file', file);
      if (to) fd.append('toMail', to);
      if (cc) fd.append('ccMail', cc);
      return this.http.post<any>(`${this.base}/${uuid}/resend`, fd);
    }
    return this.http.post<any>(`${this.base}/${uuid}/resend`, { toMail: to, ccMail: cc });
  }

  // Reintenta el envio de un correo fallido
  retry(uuid: string): Observable<any> {
    return this.http.post<any>(`${this.base}/${uuid}/retry`, {});
  }
}
